import { render } from "./FaceQRReloadSectionCenteredQR.vue?vue&type=template&id=445295b0&scoped=true"
import script from "./FaceQRReloadSectionCenteredQR.vue?vue&type=script&lang=js"
export * from "./FaceQRReloadSectionCenteredQR.vue?vue&type=script&lang=js"

import "./FaceQRReloadSectionCenteredQR.vue?vue&type=style&index=0&id=445295b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-445295b0"

export default script